export const PATH = {
  HOME: '/',
  LOGIN: '/login',
  UNAUTHORIZED: '/403',
  NOT_FOUND_PAGE: '/400',
  INTERNAL_ERR_PAGE: '/500',
  MOBILE: [/^\/mobile$/, /^\/report\/task\/\d+$/],
};
